module.exports = __webpack_public_path__ + "static/img/swiper6.78f970f6.png";